import TableCompo from "../../components/table/TableCompo";
import useCleanupOnRouteChange from "../../utilities/Cleanup";
import usePaginatedData from "../../utilities/Paginationdata";

const Booking_outstation = () => {
    const {
        data,
        prevData,
        page,
        setPage,
        isLoading,
        message,
        inputValue,
        handleSearch,
        filterValue,
        handleFilter,
    } = usePaginatedData({
        url: `${process.env.REACT_APP_URL}/api/outstation/fetchOutstationTrips`,
        localKeys: {
            search: 'search-outstation-trips',
            filter: 'filter-outstation-trips',
            page: 'pageno-outstation-trips',
            totalPage: 'totalpage-outstation-trips',
            totalData: 'totaldata-outstation-trips',
        },
        enableSearch: true,
        enableFilter: false,
    });

    console.log('data returned from the p page', data,
        prevData,
        page,
        setPage,
        isLoading,
        message,
        inputValue,
        handleSearch,
        filterValue,
        handleFilter)

    const filterOptions = [
        { value: 'verified', label: 'Verified', name: 'verification' },
        { value: 'notverified', label: 'Not verified', name: 'verification' },
        { value: 'online', label: 'Online', name: 'status' },
        { value: 'Ura premium', label: 'Ura Premium', name: 'medium' },
        { value: 'Ura Car', label: 'Ura Car', name: 'medium' },
        { value: 'Ura Bike', label: 'Ura Bike', name: 'medium' },
    ];

    useCleanupOnRouteChange(
        ['search-outstation-trips', 'filter-outstation-trips', 'totalpage-outstation-trips', 'totaldata-outstation-trips', 'pageno-outstation-trips'],
        '/outstation/bookings');

    return (
        <TableCompo
            title="Outstation Bookings"
            data={data}
            prevData={prevData}
            page={page}
            setPage={setPage}
            isLoading={isLoading}
            message={message}
            search={true}
            view={true}
            pagination={true}
            navPath={'details'}
            handleSearch={handleSearch}
            filter={false}
            filterval={handleFilter}
            fil={filterValue}
            filterOptions={filterOptions}
        />
    );
};

export default Booking_outstation;
